import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {all, fork, put, takeEvery} from "redux-saga/effects";
import LabelService from '../../services/label.service';

function* getLabelsList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const parent_label_id = action.payload?.parent_label_id
      // const role = action.payload?.roleName;
      const search = action.payload?.search;
      const status = action.payload?.status;
      let params = {page, pageSize, search, parent_label_id,status};
      let response = null;

      if (parent_label_id) {
        response = yield LabelService.listByParentLabelId(params);
      } else {
        response = yield LabelService.list(params);
      }
      if (response?.data.statusCode === 200) {
        yield put(actions.getLabelsListSuccess(response?.data?.data));
      } else {
        yield put(actions.getLabelsListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getLabelsListFailure(error));
  }
}

function* getLabelsListSaga() {
  yield takeEvery(actionsTypes.GET_LABELS_LIST_START, getLabelsList);
}

function* getLabelServiceList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      // const role = action.payload?.roleName;
      const search = action.payload?.search;
      const status = action.payload?.statusType;
      const label_id = action.payload?.label_id;
      const service_id = action.payload?.activeService.value;
      let params = {page, pageSize, search, status, label_id, service_id,};

      const response = yield LabelService.labelServiceList(params);
      if (response?.data.statusCode === 200) {
        yield put(actions.getLabelServiceListSuccess(response?.data?.data));
      } else {
        yield put(actions.getLabelServiceListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getLabelServiceListFailure(error));
  }
}

function* getLabelsServiceListSaga() {
  yield takeEvery(actionsTypes.GET_LABELS_SERVICE_LIST_START, getLabelServiceList);
}

function* getParentLabelList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;

      let params = {page, pageSize, search,};

      const response = yield LabelService.parentLabelList(params);

      if (response?.data.statusCode === 200) {
        yield put(actions.getParentLabelListSuccess(response?.data?.data));
      } else {
        yield put(actions.getParentLabelListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getParentLabelListFailure(error));
  }
}

function* getParentLabelListSaga() {
  yield takeEvery(actionsTypes.GET_PARENT_LABELS_LIST_START, getParentLabelList);
}

function* getParentLabelData(action) {
  try {
    if (action.payload) {

      const parent_label_id = action.payload?.parent_label_id

      let params = {id: parent_label_id};

      let response = yield LabelService.getParentLabelData(params);

      if (response?.data.statusCode === 200) {
        yield put(actions.getParentLabelDataSuccess(response?.data?.data));
      } else {
        yield put(actions.getParentLabelDataFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getParentLabelDataFailure(error));
  }
}

function* getParentLabelDataSaga() {
  yield takeEvery(actionsTypes.GET_PARENT_LABEL_DATA_START, getParentLabelData);
}

function* addParentLabel(action) {
  try {
    if (action.payload) {
      const response = yield LabelService.createParentLabel(action.payload);

      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}

function* addParentLabelSaga() {
  yield takeEvery(actionsTypes.ADD_NEW_PARENT_LABEL_START, addParentLabel);
}

function* uploadLabelsList(action) {
  try {
    if (action.payload) {
      console.log('upload label: ',action.payload);
      const response = yield LabelService.createLabelsList(action.payload.data);
      console.log({response})
      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}

function* uploadLabelsListSaga() {
  yield takeEvery(actionsTypes.UPLOAD_LABELS_LIST_START, uploadLabelsList);
}

function* addNewLabel(action) {
  try {
    if (action.payload) {
      let response = null;
      let payload = action.payload
      // const

      if (payload.create) {
        delete payload.create;
        response = yield LabelService.createNewLabel(action.payload);
      } else {
        delete payload.create;
        let data = payload;
        delete data.id
        let label_id = data.label_id;
        if (data.newLabelId) {
          data = {...data, label_id: data.newLabelId}
          delete data.newLabelId

        }
        response = yield LabelService.editLabel(label_id, data);
      }

      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}

function* addNewLabelSaga() {
  yield takeEvery(actionsTypes.ADD_NEW_LABEL_START, addNewLabel);
}

////////edit////////
function* editLabelService(action) {
  try {
    if (action.payload) {
      let response = null;
      let payload = action.payload
      // const

      if (payload.create) {
        delete payload.create;
        response = yield LabelService.createLabelService(action.payload);
      } else {
        delete payload.create;
        let data = payload;
        console.log('data', data);
        let id = data.id;
        delete data.id
        if (data.newLabelId) {
          data = {...data, id: data.newLabelId}
          delete data.newLabelId

        }
        response = yield LabelService.editLabelService(id, data);
      }

      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}
// function* addNewLabelService(action) {
//   try {
//     if (action.payload) {
//       const response = yield LabelService.createLabelService(action.payload);
//       if (response?.data.statusCode) {
//         yield put(actions.addNewLabelSuccess(response?.data));
//       } else {
//         yield put(actions.addNewLabelFailure("no data"));
//       }
//     }
//   } catch (err) {
//     let error = err?.response?.data?.message;

//     if (!error) {
//       error = "network error"
//     }
//     yield put(actions.addNewLabelFailure(error));
//   }
// }
function* addNewLabelService(action) {
  try {
    if (action.payload) {
      const response = yield LabelService.createLabelService(action.payload);
      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}

function* addNewLabelServiceSaga() {
  yield takeEvery(actionsTypes.ADD_NEW_LABEL_SERVICE_START, addNewLabelService);
}
function* editLabelServiceSaga() {
  yield takeEvery(actionsTypes.EDIT_LABEL_SERVICE_START, editLabelService);
}

function* licenseLabelStart(action) {
  try {
    if (action.payload) {
      // yield put(actions.addNewLabelSuccess({message: 'success'}));
      const response = yield LabelService.licenseLabelService(action.payload);
      if (response?.data.statusCode) {
        yield put(actions.addNewLabelSuccess(response?.data));
      } else {
        yield put(actions.addNewLabelFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewLabelFailure(error));
  }
}

function* licenseLabelStartSaga() {
  yield takeEvery(actionsTypes.LICENSE_LABEL_START, licenseLabelStart);
}

export function* labelSaga() {
  yield all([
    fork(getLabelsListSaga),
    fork(getLabelsServiceListSaga),
    fork(getParentLabelListSaga),
    fork(addParentLabelSaga),
    fork(addNewLabelSaga),
    fork(addNewLabelServiceSaga),
    fork(editLabelServiceSaga),
    fork(getParentLabelDataSaga),
    fork(licenseLabelStartSaga),
    fork(uploadLabelsListSaga),
  ]);
}
